import styled from 'styled-components'

export const MenuToggleButton = styled.div`
  position: absolute;
  bottom: 100px;
  right: 40px;
  z-index: 10;
  width: 60px;
  height: 60px;
  border-radius: 2px;
  background-color: #073c7a;
  box-shadow: 0 1px 20px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;

  &:hover {
    background-color: #052b5a;
  }

  &.active {
    background-color: white;

    &:hover {
      background-color: #f0f0f0;
    }
  }

  img {
    width: 24px;
    height: 24px;
  }
`

export const MenuPanel = styled.div`
  position: absolute;
  bottom: 168px;
  right: 40px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.97);
  border-radius: 4px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
  padding: 12px;
  min-width: 220px;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 13px;
  color: #333;
`

export const MenuTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
  color: #073c7a;
`

export const MenuButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 2px;
  background: ${({ $active }) => ($active ? '#073c7a' : '#f0f0f0')};
  color: ${({ $active }) => ($active ? '#fff' : '#333')};
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.15s;
  margin-bottom: 6px;

  &:hover {
    background: ${({ $active }) => ($active ? '#052b5a' : '#e0e0e0')};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:last-child {
    margin-bottom: 0;
  }
`

export const MenuDivider = styled.div`
  height: 1px;
  background: #e0e0e0;
  margin: 8px 0;
`

export const MenuDescription = styled.div`
  font-size: 11px;
  color: #666;
  padding: 0 10px 8px 0px;
  line-height: 1.4;
`

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 6px 0;
  margin-bottom: 4px;
`

export const ToggleLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #333;
`

export const ToggleSwitch = styled.button<{ $active: boolean }>`
  position: relative;
  width: 40px;
  height: 22px;
  border-radius: 11px;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  background: ${({ $active }) => ($active ? '#073c7a' : '#ccc')};
  padding: 0;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${({ $active }) => ($active ? '20px' : '2px')};
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    transition: left 0.2s;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }
`

export const HiddenCount = styled.span`
  font-size: 11px;
  color: #999;
  margin-left: 4px;
`

export const CapturedOverlay = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  object-fit: fill;
  pointer-events: auto;
  cursor: default;
`

export const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  margin-bottom: 4px;
  cursor: pointer;
  user-select: none;
`

export const CheckboxInput = styled.input`
  width: 16px;
  height: 16px;
  accent-color: #073c7a;
  cursor: pointer;
  flex-shrink: 0;
  margin: 0;
`

export const CheckboxLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #333;
`

export const CapturedBadge = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 11;
  background: rgba(7, 60, 122, 0.85);
  color: #fff;
  padding: 6px 12px;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 600;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  pointer-events: none;
`
